import React, { useEffect, useState } from "react";
import style from "./QuestionMain.module.scss";
import LeftWidget from "./components/LeftWidget";
import Item from "./components/Item";
import Header from "../../../components/Header";
import QuestionHeader from "./components/QuestionHeader";
import useRequest from "../../../utils/useRequest";
import { getTeacherCourse, getDufeTea } from "../../../service/service";
import LoadingWrapper from "../../../components/LoadingWrapper";
import _ from "underscore";
import { Empty } from "antd";

interface IQuestion {
    tid: string;
    pid: string;
    title: string;
    name: string;
    className: string;
    addtime: string;
    state: string;
}

export default function PageQuestionMain() {
    const [courseList, { loading }] = useRequest(() => getTeacherCourse());

    let [dufeTeaList, setDufeTeaList] = useState<IQuestion[]>([]);
    let [lmsCourseNo, setLmsCourseNo] = useState("");
    // 0 未 1 已 2 全部
    let [answerfilter, setAnswerFilter] = useState<number>(2);

    useEffect(() => {
        if (!courseList || courseList.length === 0) return;
        if (!lmsCourseNo) {
            lmsCourseNo = _.map(courseList, item => item.lmsCourseNo).join(",");
        }
        getDufeTea(lmsCourseNo).then(res => setDufeTeaList(res.data));
    }, [lmsCourseNo, courseList]);

    const onSelect = (value: string) => {
        setLmsCourseNo(value);
    };

    const filterSelect = (value: string) => {
        setAnswerFilter(parseInt(value));
    };

    return (
        <>
            <Header />

            <LoadingWrapper loading={loading} isEmpty={!courseList}>
                {() => (
                    <div className={style.root}>
                        <LeftWidget
                            list={courseList!}
                            lmsCourseNo={lmsCourseNo}
                            onSelect={onSelect}
                        />

                        <div className={style.main}>
                            <QuestionHeader
                                count={dufeTeaList.length}
                                onSelect={filterSelect}
                            />

                            <div className={style.list}>
                                {dufeTeaList
                                    .filter(item =>
                                        answerfilter === 2
                                            ? item
                                            : parseInt(item.state) ===
                                              answerfilter
                                    )
                                    .map(item => (
                                        <Item
                                            key={item.pid}
                                            tid={item.tid}
                                            status={item.state}
                                            title={item.title}
                                            className={item.className}
                                            name={item.name}
                                            addtime={item.addtime}
                                        />
                                    ))}
                                {dufeTeaList.filter(item =>
                                    answerfilter === 2
                                        ? item
                                        : parseInt(item.state) === answerfilter
                                ).length === 0 && (
                                    <Empty style={{ padding: 20 }} />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </LoadingWrapper>
        </>
    );
}
